import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';
import RankedDisplayWidget from "./rankedDisplayWidget.jsx"

class SearchView extends React.Component {

    constructor() {
        super();

        var hint = "";
        switch (Math.floor(Math.random() * 5))
        {
            case 0:
                hint = "Every kill increases your shot range.";
                break;
            case 1:
                hint = "Players are not allowed to travel offscreen.  Decoys are.";
                break;
            case 2:
                hint = "Your bullets will recharge over time.";
                break;
            case 3:
                hint = "Using teleport or invisibility will spawn a few random decoys on the map";
                break;
            case 4:
                hint = "Rapid fire upgrades your bullets into piercing bullets";
                break;

        }

        this.state = {
            hint: hint,
        }
    }

    clickBottomRight() {
        this.props.clickBottomRight();
    }

    genRankedWidget() {
        if (this.props.ranked) {

            return (
                <RankedDisplayWidget rank={0} score={0}/>
            );
        }
    }

    clickRankedBot() {
        this.props.clickRankedBot();
    }

    genFooter() {
        const allowBotGames = true;
        if (this.props.ranked && allowBotGames)
            return (
                <Footer clickMid={this.props.startAiGame} ranked={this.props.ranked}
                    bottomRightMessage={this.props.bottomRightMessage} clickBottomRight={this.clickBottomRight.bind(this)}/>
            );
        else
            return (
                <Footer ranked={this.props.ranked} bottomRightMessage={this.props.bottomRightMessage} clickBottomRight={this.clickBottomRight.bind(this)}/>
            );
    }

	render() {

        return (
            <div class={this.props.ranked? "mainBlue" : "main"} id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header name={this.props.ranked ? "Ranked 1v1" : "Find Game"} ranked={this.props.ranked} firstTimeRanked={this.props.firstTimeRanked} clickBack={this.props.clickBack}/>

                <div class="middle" id="search">
                    <h3>
                        { this.props.searchMessage }<div class={this.props.ranked ? "loader2" : "loader"}>Loading...</div>
                     </h3>
                     <div class={this.props.ranked ? "rankedHint" : ""}>
                         { this.props.startAiGame || (this.props.firstTimeRanked && this.props.ranked) ? "" : ("Hint: " + this.state.hint) }
                     </div>
                </div>

                { this.genFooter() }

                { this.genRankedWidget() }
            </div>
        );
	}
}

SearchView.propTypes = {
    firstTimeRanked: PropTypes.bool,
    clickBack: PropTypes.func,
    searchMessage: PropTypes.string,
    startAiGame: PropTypes.func,
    clickBottomRight: PropTypes.func,
    clickRankedBot: PropTypes.func,
    bottomRightMessage: PropTypes.string,
    ranked: PropTypes.bool,
};

export default SearchView;